<div class="app-isf-ocr-quick-fix-inter-hts-code-details">
  <div class="app-isf-ocr-quick-fix-inter-hts-code-details__row">
    <app-section-form-block-layout
      *ngIf="!!manufacturerFields"
      [formGroup]="formGroup"
      [editBlockDescription]="!!seller && isEditMode && !isSellerAssignedToOtherManufacturer ? 'LABELS.OR_ADD_DETAILS' : ''"
      [fields]="manufacturerFields"
      [displayFields]="manufacturerDisplayFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="false"
      [headerTitle]="manufacturerTitle"
      [isHeaderTitleUpperCase]="true"
      editBlockClass="normal-gap"
      (edit)="onBlockEdit($event)"
    >
      <ng-container *ngIf="isEditMode" section-body-header>
        <div class="app-isf-ocr-quick-fix-inter-hts-code-details__row">
          <p class="app-isf-ocr-quick-fix-inter-hts-code-details__text m-0">
            {{ "INFO.MF.SUB_TITLE" | translate }}
          </p>
          <p *ngIf="!!seller && !isSellerAssignedToOtherManufacturer" class="app-isf-ocr-quick-fix-inter-hts-code-details__hint-text">
            {{ "LABELS.USE_PREV_INFO" | translate }}
          </p>
        </div>

        <div class="app-isf-ocr-quick-fix-inter-hts-code-details__row">
          <app-entity-unify-card
            *ngIf="!!seller && !isSellerAssignedToOtherManufacturer"
            [entity]="seller"
            [formGroup]="formGroup"
            [code]="enumEntityModelCode.MANUFACTURER"
            [selectedValueControl]="formGroup.get('id')"
            [labelOverride]="'INFO.MF.USE_SE'"
            [isDesktop]="isDesktop"
          ></app-entity-unify-card>
        </div>
      </ng-container>

      <address-update
        edit-block-body
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.MANUFACTURER"
        [errors]="formErrors"
        [isShowState]="true"
        [isShowCountry]="true"
        [isDesktop]="true"
        [defaultCountry]="null"
        [isFilterRestrictedCountries]="false"
      ></address-update>
    </app-section-form-block-layout>
  </div>

  <ng-container *ngIf="isEditMode">
    <hr class="app-isf-ocr-quick-fix-inter-hts-code-details__hr" />

    <div class="app-isf-ocr-quick-fix-inter-hts-code-details__clear-form-btn" (click)="onClearForm()">
      <i class="fa fa-trash btn-remove-icon"></i>
      {{ "FORM_LABEL.CLEAN_FORM" | translate }}
    </div>
  </ng-container>

  <div class="app-isf-ocr-quick-fix-inter-hts-code-details__header mt-4">
    <div class="app-isf-ocr-quick-fix-inter-hts-code-details__header__left">
      <p class="app-isf-ocr-quick-fix-inter-hts-code-details__header__title">
        {{ "ENTITY.INTERNATIONAL_HTS_CODE" | translate | uppercase }}
      </p>
    </div>
  </div>

  <div class="app-isf-ocr-quick-fix-inter-hts-code-details__row">
    <p class="app-isf-ocr-quick-fix-inter-hts-code-details__text">
      {{ "INFO.HTS.SUB_TITLE_DESKTOP" | translate }}
    </p>

    <p [innerHTML]="'INFO.HTS.SUB_TITLE' | translate" class="app-isf-ocr-quick-fix-inter-hts-code-details__hint-text"></p>
  </div>

  <div *ngFor="let htsFormGroup of htsFormGroups; let idx = index" class="row app-isf-ocr-quick-fix-inter-hts-code-details__row">
    <div class="col-12" [ngClass]="{ 'col-md-11': isDesktop }">
      <div class="form-row">
        <div class="col-6">
          <app-isf-hts-control
            [fc]="htsFormGroup.get('number')"
            [isShowLabel]="idx === 0"
            [isShowPlaceholder]="true"
            [isShowHelper]="false"
          ></app-isf-hts-control>
        </div>
        <div class="col-6">
          <auto-select
            [label]="idx === 0 ? 'FORM_LABEL.COUNTRY_OF_ORIGIN' : ''"
            placeholder="FORM_PLACEHOLDER.SELECT"
            [bindLabel]="['code', 'description']"
            [bindValue]="'id'"
            [change]="searchCountry()"
            [initializeItems]="initializedCountries"
            [errors]="countryErrors"
            [fc]="htsFormGroup.get('countryOfOriginId')"
            id="countryOfOriginCode"
          ></auto-select>
        </div>
      </div>
    </div>
    <div class="col-md-1 pl-0" *ngIf="isDesktop && idx !== htsFormGroups.length - 1">
      <button type="button" class="btn btn-link hts-delete" (click)="removeHtsItem(idx)">
        <i class="fa fa-trash"></i>
      </button>
    </div>
  </div>

  <missing-fields [code]="'LABELS.ISF'" (decline)="onSubmit(false)"></missing-fields>
</div>
